import { z } from 'zod';

import { client } from '~shared/api';

export async function fetchScheduleNames() {
	const data = await client.get('/schedule/names');
	return z.array(z.string()).parse(data);
}
